<template>
  <el-container class="recharge">

    <el-header class="search">
      <el-tag type="success" class="search-balance">余额：{{userBalance}}</el-tag>
      <el-button type="primary" size="medium" class="search-reharge" plain @click="OpenDialog">充值</el-button>

      <el-input class="search-text" v-model="keyWord"  placeholder="请输入关键字检索..." @keyup.enter.native="BtnQuery"></el-input>
      <el-button type="primary" size="medium" plain icon="el-icon-search" @click="BtnQuery">查询</el-button>
    </el-header>

    <el-main>
      <div v-if="data.length > 0" class="recharge-data">
        <el-table :data="data" style="width: 100%">
                <el-table-column
                  prop="SerialNum"
                  label="卡号"
                  align="center">
                </el-table-column>

                <el-table-column
                  prop="Amount"
                  label="金额"
                  align="center">
                </el-table-column>

                <el-table-column
                  prop="UseTime"
                  label="充值时间"
                  align="center">
                </el-table-column>

<!--                <el-table-column-->
<!--                  prop="EndTime"-->
<!--                  label="有效期"-->
<!--                  align="center">-->
<!--                </el-table-column>-->
        </el-table>
      </div>

      <empty-data v-else></empty-data>
    </el-main>

    <el-footer v-if="data.length > 0" class="pagaing">
      <el-pagination
            :background="true"
            :current-page="pageIndex"
            :page-size="PageSize"
            :total="total"
            :layout="pageLayout"
            @current-change="PageChange"
            @size-change="SizeChange"
          ></el-pagination>
    </el-footer>

    <!--充值弹框-->
    <el-dialog title="充值卡充值"
        :visible.sync="rechargeVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        @close="CloseDialog"
        width="500px">

        <div class="dialog-div">
          <p class="dialog-div-p">充值卡号：</p>
          <div>
            <el-input class="dialog-text" v-model="cardAccount" placeholder="请输入充值卡卡号..."></el-input>
          </div>
        </div>
        <div class="dialog-div">
          <p class="dialog-div-p">密码：</p>
          <div>
            <el-input class="dialog-text" v-model="cardPassword" placeholder="请输入充值卡密码..." @blur="PwdValidate($event)"></el-input>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="CloseDialog">取消</el-button>
          <el-button type="primary" size="mini" @click="VerifyRechargeCard">充值</el-button>
        </span>
      </el-dialog>
    <!--充值弹框-->

  </el-container>
</template>

<script>

import { GetRechargeCardRecord, VerifyRechargeCard, CardRecharge } from "@/api/category";
import { UserInfo } from "@/api/user";
import EmptyData from "@/components/EmptyData";

export default {
    components: { EmptyData },
    data() {
        return {
            pageLayout: "total, sizes, prev, pager, next, jumper",
            loadingText: "正在加载...",
            pageIndex: 1,
            PageSize: 10,
            total: 0,
            // 列表记录
            data: [],
            // 余额
            userBalance: 0,
            // 充值卡弹框（默认关闭）
            rechargeVisible: false,
            // 充值卡账号
            cardAccount: "",
            // 充值卡密码
            cardPassword: "",
            // 充值卡面额
            cardValue: 0,
            keyWord: ""
        }
    },
    computed: {},
    watch: {},
    created() {
        this.RechargeData()
        this.getUserInfo()
    },
    methods: {
        // 充值信息
        async RechargeData() {
            const { data } = await GetRechargeCardRecord({
                pageno: this.pageIndex,
                pagesize: this.PageSize,
                searchkey: this.keyWord
            });
            if (data.code === 100) {
                this.data = data.data
                this.total = data.count
            }
        },
        // 获取用户信息
        async getUserInfo() {
            const { data } = await UserInfo();
            if (data.code === 100) {
                this.userBalance = data.data.Balance ? data.data.Balance : 0
            }
        },
        // 验证充值卡
        async VerifyRechargeCard() {
            try {
                if (!this.cardAccount) {
                    this.$message({ message: "请先填写充值卡号！", type: "error" })
                    return
                }

                if (!this.cardPassword) {
                    this.$message({ message: "请填写充值卡密码！", type: "error" })
                    return
                }

                const { data } = await VerifyRechargeCard({
                    serialNum: this.cardAccount,
                    passWord: this.cardPassword
                });

                if (data.code === 100) {
                    this.cardValue = data.data ? data.data : 0
                    this.$confirm("当前充值卡面额为：" + data.data + "， 是否确认充值?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        this.CardRecharge()
                    }).catch(() => {
                    });
                } else {
                    this.$message({ message: data.msg, type: "error" })
                }
            } catch (err) {
                this.$message({ message: "服务器繁忙，请稍后再试！", type: "error" })
            }
        },
        // 充值卡充值
        async CardRecharge() {
            try {
                const { data } = await CardRecharge({
                    serialNum: this.cardAccount,
                    passWord: this.cardPassword
                });
                if (data.code === 100) {
                    this.$message({ message: "充值成功！", type: "success" });
                    this.RechargeData()
                    this.CloseDialog()
                    // this.userBalance = (this.userBalance + 0) + (this.cardValue + 0)
                    this.getUserInfo()
                } else {
                    this.$message({ message: data.msg, type: "error" })
                }
            } catch (err) {
                this.$message({ message: "服务器繁忙，请稍后再试！", type: "error" })
            }
        },
        // 打开充值卡弹框
        OpenDialog() {
            this.rechargeVisible = true
        },
        // 关闭充值卡充值弹框
        CloseDialog() {
            this.rechargeVisible = false
            this.cardAccount = ""
            this.cardPassword = ""
        },
        // 按钮检索
        BtnQuery() {
            this.pageIndex = 1;
            this.PageSize = 10;
            this.RechargeData()
        },
        //
        PageChange(val) {
            this.pageIndex = val;
            this.RechargeData()
        },
        //
        SizeChange(val) {
            this.PageSize = val
            this.RechargeData()
        }
    }
}

</script>

<style scoped lang="less">

  .recharge{
      width: 100%;
      height: 100%;

    .el-main{
      padding: 0 0 5px 0;
      height: 600px;
      overflow: auto;
     &::-webkit-scrollbar {
           width: 6px;
       }

       &::-webkit-scrollbar-track {
           border-radius: 6px;
       }

       &::-webkit-scrollbar-thumb {
           border-radius: 6px;
           background: #BAC0CA;
       }
    }

   .el-footer{
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 40px;
    }

      .search{
        width: 100%;
        height: 40px;
        line-height: 40px;

        .search-balance{
          height: 35px;
          font-size: 15px;
          margin:0 20px 0 -20px;
        }

        .search-reharge{
          margin:0 20px 0 0;
        }

        .search-text{
          width:250px;
          margin:0 20px 0 250px;
        }

        ::v-deep .el-input__inner{
          height: 35px;
        }

      }

    .recharge-data{
       color: black;
    }

    ::v-deep .el-dialog__body{
      border-top: 1px solid #dcdfe6;
    }

    ::v-deep .el-dialog__footer{
      height: 50px;
      border-top: 1px solid #dcdfe6;
      margin-top: 20px;
    }

    .dialog-div{
      padding: 20px 0 20px 0;

      .dialog-div-p {
        width: 120px;
        text-align: right;
        float: left;
      };

      .dialog-text{
        width: 300px;
        height: 30px;
      }

    }

  }

</style>
